import React, {PureComponent, ReactNode} from 'react'

export type LoaderProps = {
    loaderSizeClass?: string
    logoSizeClass?: string
}

export class Loader extends PureComponent<LoaderProps> {
    render(): ReactNode {
        return (
            <div className="flex justify-center items-center relative">
                <div
                    className={`animate-spin rounded-full ${this.props.loaderSizeClass ? this.props.loaderSizeClass : 'h-32 w-32'} border-b-2 border-primary`}/>
                <div className="absolute">
                    <i className={`fak fa-repareo text-4xl text-gray-500`}></i>
                </div>
            </div>
        )
    }
}
